import React from "react";
import { useParams } from "react-router-dom";
import ShopCategory from "./ShopCategory";

const SellerReupVaultPage = () => {
  const { encoded_seller_id, seller_name } = useParams();

  let sellerId = "";
  try {
    sellerId = atob(encoded_seller_id);
  } catch (error) {}

  return (
    <>
      <ShopCategory
        category="ReUp Vault"
        sellerId={sellerId}
        sellerName={seller_name}
      />
    </>
  );
};

export default SellerReupVaultPage;
